const LOGO_URL = "/pniel-logo.png";
const LOGO_URL_LIGHT = "/pniel-logo-header.webp";
const CALENDLY_URL = "https://calendly.com/fsoh-pnielanalytics";
const CLUTCH_URL = "https://clutch.co/profile/pniel-analytics";

const PHONE_DISPLAY = "(302) 455-7460";
const PHONE_TEL = "+13024557460";
const CONTACT_EMAIL = "info@pnielanalytics.com";
const CAREERS_EMAIL = "careers@pnielanalytics.com";
const ADDRESS = { city: "Newark", region: "DE", postal: "19713", country: "US" };
const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Pniel Analytics LLC, Newark, DE 19713");
const MAP_EMBED_URL = "https://www.google.com/maps?q=" + encodeURIComponent("Pniel Analytics LLC, Newark, DE 19713") + "&output=embed";
const GOOGLE_BUSINESS_URL = "https://maps.google.com/?cid=18096362286209035034";

// Primary author / principal. Keep in sync with scripts/prerender.js AUTHOR.
const AUTHOR = {
  name: "Frederick Soh",
  title: "Founder & Principal Consultant",
  path: "/about/frederick-soh",
  url: "https://pnielanalytics.com/about/frederick-soh",
  linkedin: "https://www.linkedin.com/in/fredericksoh/",
  tableau: "https://public.tableau.com/app/profile/frederick2489/vizzes",
};

export { LOGO_URL, LOGO_URL_LIGHT, CALENDLY_URL, CLUTCH_URL, PHONE_DISPLAY, PHONE_TEL, CONTACT_EMAIL, CAREERS_EMAIL, ADDRESS, MAPS_URL, MAP_EMBED_URL, GOOGLE_BUSINESS_URL, AUTHOR };
